// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoBlock_wrapper__RUMSd","icon":"InfoBlock_icon__n6c9N","text":"InfoBlock_text__q26CQ"};